import { ChevronDown, ChevronRight } from "lucide-react";
import type { AssistantActivityTurnTimelineItem } from "../../types";
import { AssistantLinkedText } from "../assistant-linked-text";

export function ActivityTurnHeader({
  canExpand,
  expanded,
  headerHasLinks,
  headerLabel,
  headerParts,
  onToggle,
}: {
  canExpand: boolean;
  expanded: boolean;
  headerHasLinks: boolean;
  headerLabel: string;
  headerParts: AssistantActivityTurnTimelineItem["summaryTextParts"];
  onToggle: () => void;
}) {
  if (!canExpand) {
    return (
      <div className="py-1 text-xs text-muted-foreground">
        <span>
          <AssistantLinkedText parts={headerParts} fallback={headerLabel} />
        </span>
      </div>
    );
  }

  const icon = expanded ? (
    <ChevronDown aria-hidden="true" className="size-3.5 shrink-0" />
  ) : (
    <ChevronRight aria-hidden="true" className="size-3.5 shrink-0" />
  );

  if (headerHasLinks) {
    return (
      <div className="group flex w-full items-center gap-1.5 rounded-sm py-1 text-left text-xs text-muted-foreground transition-colors hover:text-foreground">
        <button
          type="button"
          className="rounded-sm text-muted-foreground transition-colors hover:text-foreground focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring"
          onClick={onToggle}
          aria-expanded={expanded}
          aria-label={expanded ? "Collapse activity turn" : "Expand activity turn"}
        >
          {icon}
        </button>
        <span className="truncate">
          <AssistantLinkedText parts={headerParts} fallback={headerLabel} />
        </span>
      </div>
    );
  }

  return (
    <button
      type="button"
      className="group flex w-full items-center gap-1.5 rounded-sm py-1 text-left text-xs text-muted-foreground transition-colors hover:text-foreground"
      onClick={onToggle}
    >
      {icon}
      <span className="truncate">
        <AssistantLinkedText parts={headerParts} fallback={headerLabel} />
      </span>
    </button>
  );
}
